import { currentLocale } from '@trello/locale';

const numberFormatter = new Intl.NumberFormat(currentLocale);
const compactNumberFormatter = new Intl.NumberFormat(currentLocale, {
  //@ts-ignore
  notation: 'compact',
  // @ts-ignore
  compactDisplay: 'short',
  minimumFractionDigits: 0,
  maximumFractionDigits: 1,
});
const percentageFormatter = new Intl.NumberFormat(currentLocale, {
  style: 'percent',
});
const twoDecimalFormatter = new Intl.NumberFormat(currentLocale, {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
const taxRateFormatter = new Intl.NumberFormat(currentLocale, {
  style: 'percent',
  minimumFractionDigits: 4,
  maximumFractionDigits: 4,
});

export const asNumber = (val: number) => numberFormatter.format(val);
export const asCompactNumber = (val: number) =>
  compactNumberFormatter.format(val);
export const asPercentage = (val: number) => percentageFormatter.format(val);
export const asMoney = (val: number, normalRounding: boolean = false) => {
  if (normalRounding) {
    return twoDecimalFormatter.format(val);
  } else {
    // Trello displays prices like 9.999 as $9.99
    return twoDecimalFormatter.format(Math.floor(val * 100) / 100);
  }
};
export const asTaxRate = (val: number) => taxRateFormatter.format(val);
